'use client';

import type { Referral } from '@/api/entities';
import { Share } from '@/components/icons/share';
import { useUser } from '@/components/providers/user-provider';
import { TabNavigation } from '@/components/tab-navigation';
import { Button } from '@/components/ui/button';
import { cn, formatDate } from '@/lib/utils';
import Image from 'next/image';
import * as React from 'react';
interface UserListProps {
  users: Referral[] | undefined;
  className?: string;
  type: string;
  selectedType: string;
  setSelectedType: (type: string) => void;
}
const userListTabs = [{
  name: 'Registered users'
}, {
  name: 'Enrolled users'
}];
export function UserList({
  users,
  className,
  type,
  selectedType,
  setSelectedType
}: UserListProps) {
  const {
    user
  } = useUser();
  const referralLink = user?.referralURL as string;
  const handleShare = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    const completeReferralLink = `${referralLink}`;
    const imagePath = '/referral-banner.jpeg';
    const imageResponse = await fetch(imagePath);
    const imageBlob = await imageResponse.blob();
    // TODO : check for the possiblity of adding openimage
    const shareData: ShareData = {
      title: 'Referral link',
      text: `Use this link to signup:`,
      url: completeReferralLink,
      files: []
    };
    if (navigator.canShare && navigator.canShare({
      files: [new File([imageBlob], 'referral-banner.jpeg', {
        type: imageBlob.type
      })]
    })) {
      shareData.files = [new File([imageBlob], 'referral-banner.jpeg', {
        type: imageBlob.type
      })];
    }
    try {
      await navigator.share(shareData);
    } catch (error) {
      console.error('Error sharing the course:', error);
    }
  };
  return <div className={cn(`mt-2 flex w-full flex-1 flex-col overflow-hidden rounded-lg border border-solid bg-white border-black/10 pb-1.5 shadow-[0px_2px_8px_rgba(0,0,0,0.09)] max-md:max-w-full md:max-w-[460px] md:mb-10`, className)} data-sentry-component="UserList" data-sentry-source-file="user-list.tsx">
      <TabNavigation tabs={userListTabs} activeTab={selectedType} className=" w-full flex-1 bg-white px-1 [&>button]:flex-1 " onClick={tab => setSelectedType(tab)} data-sentry-element="TabNavigation" data-sentry-source-file="user-list.tsx" />
      {/* <div className="w-full flex-1 shrink gap-1 self-stretch p-4 text-lg font-semibold tracking-normal text-zinc-900 max-md:max-w-full">
        Users
        {' '}
        {type}
        {' '}
        by me
       </div> */}

      {/* Empty state when no users are enrolled */}
      {!users || users.length === 0 ? <div className="flex flex-col items-center justify-center gap-6 p-5 text-center">
              <div className="mb-4 flex w-full justify-center">
                <Image src="/referral.svg" height={142} width={160} alt="Batch not found">

                </Image>
              </div>
              <div>
                <h3 className=" font-semibold">
                  No
                  {' '}
                  {' '}
                  {type === 'Enrolled users' ? 'enrolment' : 'registered users'}
                  {' '}
                  found!
                </h3>
                <p className="mt-2 text-sm text-neutral-500">
                  Share your referral link to your friends and
                  family to earn up to ₹2,000 per referral purchase.
                </p>
              </div>
              <Button className="w-full font-normal active:bg-blue-600" onClick={handleShare}>
                Share link
                {' '}
                <Share />
              </Button>
            </div> : users?.map(referal => <div key={referal.id} className="flex w-full items-center gap-3.5 pl-5 max-md:max-w-full">
              <Image width={100} height={100} loading="lazy" src="/default-user.svg" alt={`${referal.name}'s avatar`} className="my-auto aspect-square w-[30px] shrink-0 self-stretch rounded-[57px] object-contain" />
              <div className="my-auto flex min-h-[56px] flex-1 shrink basis-0 items-center gap-3.5 self-stretch border-black/10 py-3 pr-5 md:min-w-[240px]">
                <div className="my-auto flex flex-1 shrink basis-0 flex-col justify-center self-stretch md:min-w-[240px]">
                  <div className="text-sm font-medium tracking-normal text-neutral-700">
                    {referal.name}
                  </div>
                  <div className="text-xs text-stone-500">{formatDate(type === 'Registered users' ? referal.registeredAt : referal.enrolledAt as string)}</div>
                </div>
                {referal.earnedAmount ? type === 'Registered users' ? <Image height={100} width={100} loading="lazy" src="/Single-Gold-coin.svg" alt="" className="aspect-square w-[25px] shrink-0 rounded-md object-contain" /> : <div className="my-auto self-stretch text-center text-base font-medium tracking-tight text-zinc-900">
                              ₹
                              {referal.earnedAmount.toLocaleString()}
                            </div> : null}
              </div>
            </div>)}
    </div>;
}
;